import { render, staticRenderFns } from "./phone_login.vue?vue&type=template&id=2b36a510&scoped=true&"
import script from "./phone_login.vue?vue&type=script&lang=js&"
export * from "./phone_login.vue?vue&type=script&lang=js&"
import style0 from "./phone_login.vue?vue&type=style&index=0&id=2b36a510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36a510",
  null
  
)

export default component.exports